import { createContext } from 'react';

export const CallBackContext = createContext();
